/** @jsxImportSource solid-js */

import { Component, JSX, untrack } from 'solid-js';
import {
  CommentApiServiceProvider,
  CommentContextProvider,
  IUser,
} from '@tc-comments/providers';

export interface ICommentProviderProps {
  readonly children: JSX.Element;
  readonly accessToken: string;
  readonly currentUser: IUser;
  readonly projectId: string;
  readonly issueId: string;
  readonly apiBaseUrl?: string;
  // Added for AttachmentPicker integration
  readonly tcpsApiDomain?: string;
}

/**
 * CommentProvider provides the necessary context and API services
 * for comment-related components. Wrap your comment components with this
 * to enable API functionality and state management.
 */
// eslint-disable-next-line sonarjs/cognitive-complexity -- MERCATOR-713: complexity 19 > 15 allowed; refactor later
const CommentProvider: Component<ICommentProviderProps> = (props) => {
  if (!untrack(() => props.accessToken)) {
    console.error('CommentProvider: accessToken is required');
  }
  if (!untrack(() => props.currentUser)) {
    console.error('CommentProvider: currentUser is required');
  }
  if (!untrack(() => props.projectId)) {
    console.error('CommentProvider: projectId is required');
  }
  if (!untrack(() => props.issueId)) {
    console.error('CommentProvider: issueId is required');
  }

  return (
    <>
      {!props.accessToken ? (
        <div class="error-message">
          CommentProvider: accessToken is required
        </div>
      ) : !props.currentUser ? (
        <div class="error-message">
          CommentProvider: currentUser is required
        </div>
      ) : !props.projectId ? (
        <div class="error-message">CommentProvider: projectId is required</div>
      ) : !props.issueId ? (
        <div class="error-message">CommentProvider: issueId is required</div>
      ) : (
        <CommentApiServiceProvider
          accessToken={props.accessToken}
          configuration={
            props.apiBaseUrl ? { apiBaseUrl: props.apiBaseUrl } : undefined
          }
        >
          <CommentContextProvider
            initialState={{
              currentUser: props.currentUser,
              projectId: props.projectId,
              issueId: props.issueId,
              accessToken: props.accessToken,
              tcpsApiDomain: props.apiBaseUrl || null,
            }}
          >
            {props.children}
          </CommentContextProvider>
        </CommentApiServiceProvider>
      )}
    </>
  );
};

export default CommentProvider;
